export default {
    'pages.layouts.userLayout.title':
    'Ant Design 是西湖区最具影响力的 Web 设计规范',
    'pages.login.accountLogin.tab': '账户密码登录',
    'pages.login.accountLogin.errorMessage':
    '错误的用户名和密码(admin/ant.design)',
    'pages.login.failure': '登录失败，请重试！',
    'pages.login.success': '登录成功！',
    'pages.login.username.placeholder': '用户名: admin or user',
    'pages.login.username.required': '用户名是必填项！',
    'pages.login.password.placeholder': '密码: ant.design',
    'pages.login.password.required': '密码是必填项！',
    'pages.login.phoneLogin.tab': '手机号登录',
    'pages.login.phoneLogin.errorMessage': '验证码错误',
    'pages.login.phoneNumber.placeholder': '请输入手机号！',
    'pages.login.phoneNumber.required': '手机号是必填项！',
    'pages.login.phoneNumber.invalid': '不合法的手机号！',
    'pages.login.captcha.placeholder': '请输入验证码！',
    'pages.login.captcha.required': '验证码是必填项！',
    'pages.login.phoneLogin.getVerificationCode': '获取验证码',
    'pages.getCaptchaSecondText': '秒后重新获取',
    'pages.login.rememberMe': '自动登录',
    'pages.login.forgotPassword': '忘记密码 ?',
    'pages.login.submit': '登录',
    'pages.login.loginWith': '其他登录方式 :',
    'pages.login.registerAccount': '注册账户',
    'pages.welcome.link': '欢迎使用',
    'pages.welcome.alertMessage': '更快更强的重型组件，已经发布。',
    'pages.404.subTitle': '抱歉，您访问的页面不存在。',
    'pages.404.buttonText': '返回首页',
    'pages.admin.subPage.title': ' 这个页面只有 admin 权限才能查看',
    'pages.admin.subPage.alertMessage':
    'umi ui 现已发布，欢迎使用 npm run ui 启动体验。',
    'pages.searchTable.createForm.newRule': '新建规则',
    'pages.searchTable.updateForm.ruleConfig': '规则配置',
    'pages.searchTable.updateForm.basicConfig': '基本信息',
    'pages.searchTable.updateForm.ruleName.nameLabel': '规则名称',
    'pages.searchTable.updateForm.ruleName.nameRules': '请输入规则名称！',
    'pages.searchTable.updateForm.ruleDesc.descLabel': '规则描述',
    'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '请输入至少五个字符',
    'pages.searchTable.updateForm.ruleDesc.descRules':
    '请输入至少五个字符的规则描述！',
    'pages.searchTable.updateForm.ruleProps.title': '配置规则属性',
    'pages.searchTable.updateForm.object': '监控对象',
    'pages.searchTable.updateForm.ruleProps.templateLabel': '规则模板',
    'pages.searchTable.updateForm.ruleProps.typeLabel': '规则类型',
    'pages.searchTable.updateForm.schedulingPeriod.title': '设定调度周期',
    'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '开始时间',
    'pages.searchTable.updateForm.schedulingPeriod.timeRules': '请选择开始时间！',
    'pages.searchTable.titleDesc': '描述',
    'pages.searchTable.ruleName': '规则名称为必填项',
    'pages.searchTable.titleCallNo': '服务调用次数',
    'pages.searchTable.titleStatus': '状态',
    'pages.searchTable.nameStatus.default': '关闭',
    'pages.searchTable.nameStatus.running': '运行中',
    'pages.searchTable.nameStatus.online': '已上线',
    'pages.searchTable.nameStatus.abnormal': '异常',
    'pages.searchTable.titleUpdatedAt': '上次调度时间',
    'pages.searchTable.exception': '请输入异常原因！',
    'pages.searchTable.titleOption': '操作',
    'pages.searchTable.config': '配置',
    'pages.searchTable.subscribeAlert': '订阅警报',
    'pages.searchTable.title': '查询表格',
    'pages.searchTable.new': '新建',
    'pages.searchTable.chosen': '已选择',
    'pages.searchTable.item': '项',
    'pages.searchTable.totalServiceCalls': '服务调用次数总计',
    'pages.searchTable.tenThousand': '万',
    'pages.searchTable.batchDeletion': '批量删除',
    'pages.searchTable.batchApproval': '批量审批',
    'pages.lifecycle-tracking.enabled': '启用生命周期跟踪',
    'pages.lifecycle-tracking.sampling_rate': '采样率',
    'pages.lifecycle-tracking.min_queue_duration_secs': '最小排队时长（秒）',
    'pages.lifecycle-tracking.ttl_secs': '记录保留时长（秒）',
    'pages.lifecycle-tracking.save': '保存配置',
    'pages.lifecycle-tracking.reset': '重置默认',
    'pages.lifecycle-tracking.stats_overview': '统计概览',
    'pages.lifecycle-tracking.total_records': '总记录数',
    'pages.lifecycle-tracking.matched_records': '已完成匹配',
    'pages.lifecycle-tracking.timeout_records': '超时',
    'pages.lifecycle-tracking.cancelled_records': '已取消',
    'pages.lifecycle-tracking.pending_records': '等待中',
    'pages.lifecycle-tracking.avg_queue_duration': '平均排队时长',
    'pages.lifecycle-tracking.max_queue_duration': '最大排队时长',
    'pages.lifecycle-tracking.completion_rate': '匹配完成率分析',
    'pages.lifecycle-tracking.total_completion_rate': '总完成率',
    'pages.lifecycle-tracking.success_rate': '成功匹配率',
    'pages.lifecycle-tracking.timeout_rate': '超时率',
    'pages.lifecycle-tracking.cancel_rate': '取消率',
    'pages.lifecycle-tracking.data_management': '数据管理',
    'pages.lifecycle-tracking.cleanup_records': '清理过期记录',
    'pages.lifecycle-tracking.cleanup_1h': '清理1小时前',
    'pages.lifecycle-tracking.cleanup_6h': '清理6小时前',
    'pages.lifecycle-tracking.cleanup_24h': '清理1天前',
    'pages.lifecycle-tracking.cleanup_7d': '清理7天前',
    'pages.lifecycle-tracking.cleanup_30d': '清理30天前',
    'pages.lifecycle-tracking.cleanup_all': '清理全部',
    'pages.lifecycle-tracking.cleanup_success': '已清理',
    'pages.lifecycle-tracking.cleanup_all_confirm': '确定要清理全部记录吗？',
    'pages.lifecycle-tracking.usage': '使用说明',
    'pages.lifecycle-tracking.usage_title': '生命周期跟踪功能说明',
    'pages.lifecycle-tracking.usage_lifecycle': '记录 Ticket 从创建到最终状态',
    'pages.lifecycle-tracking.usage_window': '记录 Ticket 被匹配窗口选中时记录窗口快照',
    'pages.lifecycle-tracking.usage_filter': '记录 MMF 过滤原因（玩家不足、MMR范围、队伍组成等）',
    'pages.lifecycle-tracking.usage_result': '记录最终匹配结果和详细参数',
    'pages.lifecycle-tracking.usage_recommendations_title': '性能建议',
    'pages.lifecycle-tracking.usage_recommendation_1': '生产环境建议采样率设为 0.01 - 0.1，减少 Redis 写入和内存占用',
    'pages.lifecycle-tracking.usage_recommendation_2': '设置合理的 min_queue_duration_secs（如 600 秒）只记录长时间排队的 Ticket',
    'pages.lifecycle-tracking.usage_recommendation_3': '根据业务量调整 TTL（建议 1-4 小时）',
    'pages.lifecycle-tracking.usage_recommendation_4': '定期清理过期记录，避免 Redis 内存积压',
};
